module.exports = __webpack_public_path__ + "img/anuenciaCons4.cdf18b86.jpg";